import { ILoginOIDCRequest } from "../../model/request/auth/ILoginOIDCRequest";
import { apiClient } from "../apiClient";
import { apiGuestClient } from "../apiGuestClient";

export const authApi = {
    getUser: () => apiClient.get('account/info'),
    logIn: (request: ILoginOIDCRequest) => {
        // debugger
        return apiGuestClient.post(`account/login-oidc`, request)
    }

}